import { Box } from '@chakra-ui/react';
import { CustomHeading } from 'shared-components';

interface ISection {
  heading: React.ReactNode;
  children: React.ReactNode;
}

export const Section = (props: ISection) => {
  return (
    <Box mb={10}>
      <CustomHeading as="h2" level="h4">
        {props.heading}
      </CustomHeading>

      {props.children}
    </Box>
  );
};
